import { AddActivityMode } from '@/app/constants/addActivityMode'
import { getAddActivityModeName } from '@/app/services/activity/addActivityModeNameResolver'
import {
  faClockThreeThirtySolid,
  FaIcon,
  faQuestionCircleRegular,
} from '@/lib/fa'
import { useActivity } from '@/modules/drivers/stores/activityStore'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const ADD_ACTIVITY_MODES = [
  AddActivityMode.UNKNOWN,
  AddActivityMode.UNKNOWN_REST,
  AddActivityMode.EACH_ACTIVITY,
]

const ActivityOverride = () => {
  const { t } = useLocalize()
  const { data, setData } = useActivity()

  const options = ADD_ACTIVITY_MODES.map((mode) => ({
    value: String(mode),
    label: t(getAddActivityModeName(mode)),
  }))

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            Dane do zmiany
          </p>
          <Tooltip text="Wybierz, które dane aktywności mają zostać zmienione podczas nadpisywania aktywności kierowcy.">
            <FaIcon icon={faQuestionCircleRegular} />
          </Tooltip>
        </div>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <FieldsetSelect
          searchEnabled={false}
          required
          placeholder="Wybierz..."
          value={data.overrideType?.toString()}
          name="dataAddType"
          onChange={(e) => {
            setData({
              ...data,
              overrideType: Number(e.target.value) as AddActivityMode,
            })
          }}
        options={options}
        />
      </div>
    </div>
  )
}

export default ActivityOverride
